import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6aaa071b0a1ed80014749809_1789661410240_dd636fd8/angna/src/app/components/HomepageClient.tsx");
